import * as yup from 'yup';
import { CLA_SETTINGS_FLAG } from '../CLASettings.types';
import { commonBooleanValidationSchema } from '../CLASettings.schema';

export const expiryHoursInOctopusFields = [
  {
    name: `flags[${CLA_SETTINGS_FLAG.SHOW_LEAVE_PREVIOUS_YEAR_IN_OCTOPUS}]`,
    label: 'statutoryLeave1To7'
  },
  {
    name: `flags[${CLA_SETTINGS_FLAG.SHOW_ADDITIONAL_LEAVE_4_YEARS_IN_OCTOPUS}]`,
    label: 'additionalLeaveHours4Years'
  },
  {
    name: `flags[${CLA_SETTINGS_FLAG.SHOW_ADDITIONAL_LEAVE_5_YEARS_IN_OCTOPUS}]`,
    label: 'additionalLeaveHours5Years'
  },
  {
    name: `flags[${CLA_SETTINGS_FLAG.SHOW_PLB_5_YEARS_IN_OCTOPUS}]`,
    label: 'plbHours5Years'
  },
  {
    name: `flags[${CLA_SETTINGS_FLAG.SHOW_PLB_10_YEARS_IN_OCTOPUS}]`,
    label: 'plbHours10Years'
  }
];

export const expiryHoursInOctopusSchema = yup.object({
  leaveHoursPreviousYear: commonBooleanValidationSchema(),
  additionalLeaveHours4Years: commonBooleanValidationSchema(),
  additionalLeaveHours5Years: commonBooleanValidationSchema(),
  plbHours5Years: commonBooleanValidationSchema(),
  plbHours10Years: commonBooleanValidationSchema()
});
